export type DefaultDistanceArgs = {
    bid: number;
    ask: number;
    side: 'buy' | 'sell';
    kind: 'tp' | 'sl';
    minVal: number;
    maxVal: number;
    decimals: number;
};

const TAKE_PROFIT_PCT = 0.0066;
const STOP_LOSS_PCT = 0.0013;

// Smart default for a take-profit / stop-loss distance: a fixed percentage of the price the
// position would open at (ask for a buy, bid for a sell), rounded one place coarser than the
// instrument's distance precision so the seeded value reads as a round number, then clamped
// into the instrument's allowed range. The field still displays at full precision.
export function defaultDistance({ bid, ask, side, kind, minVal, maxVal, decimals }: DefaultDistanceArgs): number {
    const reference = side === 'buy' ? ask : bid;
    const raw = reference * (kind === 'tp' ? TAKE_PROFIT_PCT : STOP_LOSS_PCT);
    const candidate = Number(raw.toFixed(Math.max(0, decimals - 1)));
    if (candidate < minVal) {
        return minVal;
    }
    if (candidate > maxVal) {
        return maxVal;
    }
    return candidate;
}

// Initial quantity for the trade setup step. Normally the instrument's floor, but the engine can
// report a maximum below it (no price for the instrument, or a fund too small to buy one unit),
// and seeding above the maximum would put the field outside its own stated range.
export function seedQuantity(range: { minQuantity: number; maxQuantity: number }): number {
    return Math.min(Math.abs(Number(range.minQuantity)), Math.abs(Number(range.maxQuantity)));
}
